module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-icon-button",
    attrs: {
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused
    },
    on: {
      "click": _vm.handleClick,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit,
      "keyboardFocus": _vm.handleKeyboardFocus
    }
  }, [_vm._t("default", function() {
    return [_c('icon', {
      class: _vm.iconClass,
      attrs: {
        "value": _vm.icon
      }
    })]
  }), _vm._v(" "), (_vm.tooltip) ? _c('tooltip', {
    attrs: {
      "trigger": _vm.tooltipTrigger,
      "verticalPosition": _vm.verticalPosition,
      "horizontalPosition": _vm.horizontalPosition,
      "show": _vm.tooltipShown,
      "label": _vm.tooltip,
      "touch": _vm.touch
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bdebfa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/iconButton/iconButton.vue
// module id = 494
// module chunks = 1